<template>
  <USelectMenu
    v-model="currentValue"
    :items="items"
    label-key="title"
    by="idChargeModel"
    :placeholder="$t('components.chargeModel.elements.select.placeholder')"
    :filter-fields="['title']"
    v-bind="$attrs"
  >
    <template #default="{ modelValue: selected }">
      <div v-if="selected" class="flex items-center justify-between w-full h-full pr-2 text-sm text-gray-800 dark:text-gray-100">
        <div class="text-left">
          <p class="text-gray-800 dark:text-gray-100">
            {{ selected.title }}
          </p>
          <p class="text-gray-600">
            {{ selected.isAmountTypeFixed ? $currency.format(selected.price) : selected.price + '%' }}
          </p>
        </div>

        <o-chip v-if="selected.locked" variant="danger" size="xs">
          {{ $t('general.locked') }}
        </o-chip>
      </div>
    </template>

    <template #item="{ item }">
      <div v-if="item" class="w-full flex items-center justify-between">
        <div>
          <p class="text-gray-800 dark:text-gray-100">
            {{ item.title }}
          </p>
          <p class="text-gray-600">
            {{ item.isAmountTypeFixed ? $currency.format(item.price) : item.price + '%' }}
          </p>
        </div>

        <o-chip v-if="item.locked" variant="danger" size="xs">
          {{ $t('general.locked') }}
        </o-chip>
      </div>
    </template>
  </USelectMenu>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

import { useChargeModelStore } from '~/stores/useChargeModelStore'

interface Props {
  modelValue?: any
  filter?: Function | null
  fieldClass?: string
  placeholder?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  filter: null,
  fieldClass: 'w-full text-sm',
  placeholder: undefined,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const chargeModelStore = useChargeModelStore()

const currentValue = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

const charges = computed(() => chargeModelStore.all)

const items = computed(() => {
  let list = charges.value

  if (props.filter) {
    list = list.filter(props.filter as any)
  }

  return list
})

onMounted(() => {
  chargeModelStore.sync()
})
</script>
